/**
 * Created by intellicar-rinas on 17/11/17.
 */
import React, {Component} from 'react';
import './InPopup.css';
import Dom from '../../helpers/Dom';

class InPopup extends Component {

    constructor() {
        super();
        ['getStyle', 'onClose'].map(i=>this[i]=this[i].bind(this));

        window.addEventListener('keydown',e=>{
            if(e.keyCode === 27) {
                this.onClose('escapeKey');
            }
        })
    }

    getStyle() {
        if(this.props.height && this.props.width) {
            return {
                width: this.props.width,
                height: this.props.height,
                marginLeft: -(this.props.width / 2),
                marginTop: -(this.props.height / 2),
            }
        }
        return {};
    }

    onClose(source){
        if(this.props.onClose) {
            this.props.onClose({source:source});
        }
    }



    render() {
        return (
            <div className={Dom.Class({'active':this.props.visiblity}, "InPopup-container")}>
                <div className="InPopup" style={this.getStyle()}>
                    <div className="ip-header">
                        <div className="iph-name">{this.props.title}</div>
                        <div className="iph-close" onClick={()=>this.onClose('closeButton')}><i className="fa fa-times"></i></div>
                    </div>
                    <div className="ip-container">
                        {this.props.children}
                    </div>
                </div>
                <div className="InPopup-backdrop" onClick={()=>this.onClose('closeButton')}></div>
            </div>
        )
    }

}

export default InPopup;